<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/profile">
        <md-icon>person</md-icon>
        <p>Meus Dados</p>
      </sidebar-link>
      <sidebar-link to="/contracts">
        <md-icon>gavel</md-icon>
        <p>Contratos Pendentes</p>
      </sidebar-link>
      <sidebar-link to="/services">
        <md-icon>wifi_tethering</md-icon>
        <p>Serviços Contratados</p>
      </sidebar-link>
      <sidebar-link to="/history">
        <md-icon>credit_card</md-icon>
        <p>Financeiro</p>
      </sidebar-link>
      <sidebar-link to="/wifi">
        <md-icon>wifi</md-icon>
        <p>Meu Wi-Fi</p>
      </sidebar-link>
      <!-- <sidebar-link to="/tickets">
        <md-icon>support_agent</md-icon>
        <p>Atendimentos</p>
      </sidebar-link> -->
      <li class="md-list-item">
        <a
          class="md-list-item-router md-list-item-container md-button-clean"
          @click="exit"
        >
          <div class="md-list-item-content md-ripple">
            <md-icon>logout</md-icon>
            <p>Sair</p>
          </div>
        </a>
      </li>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content> </dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg")
    };
  },
  methods: {
    ...mapActions(["logout"]),
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    exit() {
      this.logout();
      this.$router.push("/auth/login");
    }
  }
};
</script>
